export default {
  getDetail: state => state.detail,
  getNoticeList: state => state.noticeList,
  getCondition: state => state.condition
};
